/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'doT',
	'text!./templates/TabColorSet.html',
	'../../util/ColorUtils'
], (dot, templateString, ColorUtils) => {
	/**
	 * Generate runtime styles needed by the tab control
	 */
	class TabColorSet {
		static getColorStyles(colorsService, paletteId) {
			return Promise.all([
				colorsService.getForegroundCSSColors('TabActionButtonColor', paletteId),
				colorsService.getForegroundCSSColors('TabDividerColor', paletteId),
				colorsService.getForegroundCSSColors('TabPlusHoverColor', paletteId)
			]).then(([actionButtonColors, tabDividerColor, plusHoverColors]) => {
				const mainColors = colorsService.getColorSet(paletteId);
				const areColorsFromTheme = colorsService.getColorSetId() === 'userPaletteColor';

				// Given the list of possible background colors, generate an appropriate hover color
				mainColors.forEach((color) => {
					let hexValue = color.hexValue;
					// For transparent color, get the background color of the board for the given theme
					if (color.name === 'transparent') {
						hexValue = colorsService.getValueForPropertyOfUIElement('board', 'backgroundColor');
					}

					// If we're not using 'userPaletteColor' or we're dealing with a custom color then figure out hover and button colors
					if (!areColorsFromTheme || colorsService.isCustomColor(color.name)) {
						plusHoverColors[color.name] = ColorUtils.invertColor(hexValue, 90, 100, true);
						tabDividerColor[color.name] = ColorUtils.invertColor(hexValue, 40, 100, true);
					}
				});

				return TabColorSet.dotTemplate({
					colors: mainColors,
					actionButtonColors: actionButtonColors,
					plusHoverColors: plusHoverColors,
					tabDividerColor: tabDividerColor
				});
			});
		}
	}

	TabColorSet.dotTemplate = dot.template(templateString);

	return TabColorSet;
});
